import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueScrollStop from 'vue-scroll-stop';
import '../../components/components'
import './../less/crystal-space.less'
import './layout'
import './lightbox'
import './map'
import './menu'

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueScrollStop)

Vue.prototype.$bus = new Vue();
Vue.http.options.emulateJSON = true
new Vue().$mount('#galactium')
UIkit.use(Icons)



// WEBPACK FOOTER //
// ./assets/js/crystal-space.js